module.exports = __webpack_public_path__ + "static/media/Niveau_elN7_3_117417.f651d014.png";